import DialogWithMessage from './DialogWithMessage';

export default DialogWithMessage;
